/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Pit3_DInputs */

const en_csv_to_json_pit3_d = /** @type {(inputs: Csv_To_Json_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If two columns share a header, both write to the same object key and the rightmost column overwrites the others. JSON objects cannot hold two identical keys, so nothing warns you and one column disappears. Rename the columns in the source before converting.`)
};

const ko_csv_to_json_pit3_d = /** @type {(inputs: Csv_To_Json_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`두 열이 헤더를 공유하면 둘 다 같은 객체 키에 쓰고 가장 오른쪽 열이 나머지를 덮어씁니다. JSON 객체는 동일한 키를 두 개 담을 수 없으므로 아무 경고도 없이 한 열이 사라집니다. 변환 전에 원본에서 열 이름을 바꾸세요.`)
};

const ja_csv_to_json_pit3_d = /** @type {(inputs: Csv_To_Json_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 つの列がヘッダを共有すると、両方が同じオブジェクトキーに書き込み、最も右の列がほかを上書きします。JSON のオブジェクトは同一のキーを 2 つ持てないので、何の警告もなく 1 つの列が消えます。変換前に元データで列名を変えてください。`)
};

/**
* | output |
* | --- |
* | "If two columns share a header, both write to the same object key and the rightmost column overwrites the others. JSON objects cannot hold two identical keys,..." |
*
* @param {Csv_To_Json_Pit3_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_pit3_d = /** @type {((inputs?: Csv_To_Json_Pit3_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Pit3_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_pit3_d(inputs)
	if (locale === "ko") return ko_csv_to_json_pit3_d(inputs)
	return ja_csv_to_json_pit3_d(inputs)
});